var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3486 8.66895C17.3486 13.4062 13.4062 17.3379 8.66895 17.3379C3.94238 17.3379 0 13.4062 0 8.66895C0 3.93164 3.93164 0 8.6582 0C13.3955 0 17.3486 3.93164 17.3486 8.66895ZM5.40332 7.8418C4.8125 7.8418 4.43652 8.14258 4.43652 8.69043C4.43652 9.22754 4.83398 9.51758 5.40332 9.51758H11.9561C12.5254 9.51758 12.9014 9.22754 12.9014 8.69043C12.9014 8.14258 12.5469 7.8418 11.9561 7.8418H5.40332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeIcon);
export default __webpack_public_path__ + "static/media/unsubscribe_icon.c4ef5c5ba0c828d3d1c91115d13dbc31.svg";
export { ForwardRef as ReactComponent };